<template>
  <div class="content">
    <div class="column">
      <!-- use_intervalは1daysがデフォ もし明示されているMasterSheetの場合は表示するゾーン -->
      <!-- emotパス か 浜松バルのみ 2/24時点 -->
      <!-- 利用区間/利用回数 -->

      <div v-if="masterSheet.use_interval != '1days'">
        <!-- 次に使える時刻表示 -->
        <FaceNextAvailableTime
          v-if="props.isInIntervalFlag"
          :nextTimeAvailable="props.nextTimeAvailable"
        />

        <!-- 残り回数表示 -->
        <FaceUnusedNumber
          v-if="!props.isInIntervalFlag && masterSheet.is_fixed_frame"
          :unusedFramesCount="unused_frames.length"
        />
      </div>
      <!-- 利用区間/利用回数 -->
      <!-- use_intervalが明示されているMasterSheetの場合は表示 -->

      <!-- division毎の購入枚数の表示 -->
      <BgFaceDivisionCountDisp
        v-if="divisionsInfo[0].label"
        :divisions="divisionsInfo"
      />
      <!-- division毎の購入枚数の表示 -->
    </div>

    <!-- ブックの期間を表示 -->
    <div class="column">
      <BFaceAvailablePeriodDisp
        v-if="book.user_started_at"
        :start="book.user_started_at"
        :limit="limitedAtMinusStartHour"
      />
      <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
      <BFaceAvailablePeriodDisp
        v-else
        :start="book.available_started_at"
        :limit="limitedAtMinusStartHour"
      />
    </div>
    <!-- ブックの期間を表示 -->
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import myTicketsCommonService from "@/services/common/myTickets";
import bookGroupService from "@/services/bookGroup";

export default {
  name: "TheSheetUpper",
  props: {
    isInIntervalFlag: {
      type: Boolean,
      required: false,
    },
    nextTimeAvailable: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props) {
    const store = useStore();

    const divisionsInfo = ref([{ division: null, label: null, count: null }]);

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);

    const limitedAtMinusStartHour = computed(() => {
      // book.user_XXX_atがある場合
      if (book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // book.user_XXX_atがない場合
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    const unused_frames = computed(
      () => store.getters["ticketing/unused_frames"]
    );
    onMounted(async () => {
      divisionsInfo.value = await bookGroupService.divisionArrange(
        bookGroup.value.books
      );
    });

    return {
      props,
      book,
      masterSheet,
      divisionsInfo,
      limitedAtMinusStartHour,
      unused_frames,
    };
  },
};
</script>
